import React from 'react';

import empretec1 from '../assets/empretec-1.jpg';
import empretec2 from '../assets/empretec-2.jpg';
import empretec3 from '../assets/empretec-3.jpg';
import empretec4 from '../assets/empretec-4.jpg';

import homenArena from '../assets/homen-arena.png';
import homenRural from '../assets/homen-rural.png';
import mulherEmpretec from '../assets/mulher-empretec.png';
import mulherEmpretecStartup from '../assets/mulher-startup.png';

import homenEmpretecArenaMobile from '../assets/detail-empretec-arena-mobile.png';
import mulherEmpretecMobile from '../assets/detail-empretec-mobile.png';
import homenEmpretecRuralMobile from '../assets/detail-empretec-rural-mobile.png';
import mulherEmpretecStartupMobile from '../assets/detail-empretec-startup-mobile.png';

import logoEmpretecArena from '../assets/arena.png';
import logoEmpretecRural from '../assets/rural.png';
import logoEmpretecStartup from '../assets/startup.png';
import logoEmpretec from '../assets/tradicional.png';
import { TextHeading } from '../components/modal-detail/modal-ddetail-style';

export const MAP_EMPRETEC_FREQUENT_QUESTIONS = [
  {
    id: 1,
    title: 'Para quem é o Empretec?',
    description: () => (
      <div>
        <p>
          <strong>Empreendedores:</strong> Pessoas que já têm um negócio e
          querem crescer, expandir resultados ou superar desafios para tornar
          suas operações mais eficientes e sustentáveis.
        </p>
        <br />
        <p>
          <strong>Futuros Empreendedores:</strong> Quem ainda não tirou a ideia
          do papel, mas sente o chamado de empreender. Muitas vezes lidam com
          dúvidas sobre por onde começar e buscam orientação prática para
          identificar oportunidades, traçar metas e dar os primeiros passos com
          segurança.
        </p>
        <br />
        <p>
          <strong>Decisores:</strong> Pessoas que ocupam cargos de decisão em
          organizações e que são responsáveis por iniciativas de transformação
          dentro de suas empresas.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 2,
    title: 'Como me inscrever?',
    description: () => (
      <div>
        <p>
          Antes de se inscrever, é necessário passar por uma entrevista de
          seleção. Como o seminário tem foco no desenvolvimento comportamental,
          essa etapa é fundamental para garantir a efetividade dos resultados.
        </p>
        <br />
        <p>
          A seleção é realizada por meio de uma entrevista online, gratuita,
          conduzida por uma inteligência artificial treinada na metodologia do
          Empretec. Em aproximadamente 50 minutos, você responde a 5 perguntas
          objetivas. Ao final, recebe o resultado indicando se está apto a
          participar da imersão. Caso ainda não esteja pronto, poderá refazer a
          entrevista após 3 meses.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 3,
    title:
      'Já participei de outras versões do Empretec (Rural ou Startup). \nPosso participar desta versão?',
    description: () => (
      <div>
        <p>
          Quem já participou de outras versões do Empretec — como Rural ou
          Startup não pode se inscrever nesta versão. Por outro lado, se você já
          é Empreteco, pode participar do Empretec Arena.
        </p>
        <br />
      </div>
    ),
    opened: false,
  },
  {
    id: 4,
    title: 'Qual o investimento para participar do Empretec Urbano?',
    description: () => (
      <div>
        <p>
          O investimento para participar do Empretec Urbano pode variar de
          acordo com a região. Embora a metodologia seja única e padronizada em
          todo o Brasil, cada unidade estadual do Sebrae define sua própria
          política de preços.
        </p>
        <br />
        <p>
          Para saber o valor e as condições de pagamento, acesse o site do
          Sebrae do seu estado e consulte as informações atualizadas.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 5,
    title: 'Qual é a carga horária?',
    description: () => (
      <div>
        <p>O Empretec tem carga total de 60 horas, divididas em duas etapas:</p>
        <br />
        <p>
          <strong>Pré-seminário (on-line e obrigatório): </strong> começa na
          quarta-feira anterior ao seminário presencial e exige cerca de 10
          horas de dedicação.
        </p>
        <br />
        <p>
          <strong>Seminário (presencial e imersivo): </strong> com duração de 50
          horas, acontece de segunda a sexta, em jornadas intensas de 8 horas
          por dia.
        </p>
      </div>
    ),
    opened: false,
  },
];

export const MAP_EMPRETEC_RURAL_FREQUENT_QUESTIONS = [
  {
    id: 1,
    title: 'Para quem é o Empretec Rural?',
    description: () => (
      <div>
        <p>
          <strong>Empreendedores:</strong> Pessoas que ainda não iniciaram seus
          negócios no agronegócio e sentem insegurança sobre como começar.
          Buscam orientação e ferramentas para identificar oportunidades,
          definir metas e planejar os primeiros passos de forma estratégica,
          considerando as especificidades do meio rural.
        </p>
        <br />
        <p>
          <strong>Futuros Empreendedores:</strong> Já possuem um negócio e estão
          em busca de crescimento ou de maior estabilidade. Desejam expandir,
          superar desafios na gestão e construir um novo caminho para
          impulsionar seus resultados no setor.
        </p>
        <br />
        <p>
          <strong>Decisores:</strong> Pessoas que ocupam posições de liderança
          no agronegócio e são responsáveis por impulsionar mudanças dentro das
          empresas. Esses intraempreendedores atuam de forma proativa, enfrentam
          desafios e buscam aprimorar continuamente a performance do negócio
          rural.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 2,
    title: 'Como me inscrever?',
    description: () => (
      <div>
        <p>
          Antes de se inscrever, é necessário passar por uma entrevista de
          seleção. Como o seminário tem foco no desenvolvimento comportamental,
          essa etapa é fundamental para garantir a efetividade dos resultados.
        </p>
        <br />
        <p>
          A seleção é realizada por meio de uma entrevista, gratuita, conduzida
          por um(a) selecionador (a) treinado na metodologia do Empretec. Em
          aproximadamente 50 minutos, você responde a 5 perguntas, e ao final,
          recebe o resultado indicando se está apto a participar da imersão.
          Caso ainda não esteja pronto, poderá refazer a entrevista após 3
          meses.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 3,
    title:
      'Já participei de outras versões do Empretec. \nPosso participar desta versão?',
    description: () => (
      <div>
        <p>
          Quem já participou de outras versões do Empretec não pode se inscrever
          nesta versão.
        </p>
        <br />
        <p>
          Por outro lado, se você já é Empreteco, pode participar do Empretec
          Arena.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 4,
    title: 'Qual o investimento para participar do Empretec Rural?',
    description: () => (
      <div>
        <p>
          O investimento para participar do Empretec Rural pode variar de acordo
          com a região. Embora a metodologia seja única e padronizada em todo o
          Brasil, cada unidade estadual do Sebrae define sua própria política de
          preços.
        </p>
        <br />
        <p>
          Para saber o valor e as condições de pagamento, acesse o site do
          Sebrae do seu estado e consulte as informações atualizadas.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 5,
    title: 'Qual é a carga horária?',
    description: () => (
      <div>
        <p>
          O <strong>Empretec Rural</strong> possui carga horária total de 60
          horas, distribuídas ao longo de um seminário{' '}
          <strong>presencial e imersivo.</strong>
        </p>
        <br />
        <p>
          A programação acontece de <strong>segunda a sábado</strong>, com
          jornadas intensas de 8 horas diárias.
        </p>
      </div>
    ),
    opened: false,
  },
];

export const MAP_EMPRETEC_ARENA_FREQUENT_QUESTIONS = [
  {
    id: 1,
    title: 'Para quem é o Empretec Arena?',
    description: () => (
      <div>
        <p>
          O Empretec Arena é exclusivo para quem já participou de alguma edição
          do Empretec há pelo menos um ano e deseja reviver essa experiência de
          forma ainda mais intensa, atual e desafiadora.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 2,
    title: 'Como me inscrever no Empretec Arena?',
    description: () => (
      <div>
        <p>
          Antes de se inscrever, é preciso passar por uma nova entrevista de
          seleção. Mesmo que você já tenha participado de entrevistas para
          outras edições do Empretec, essa etapa é obrigatória, pois tem o
          objetivo de avaliar a evolução dos seus comportamentos empreendedores
          ao longo do tempo.
        </p>
        <br />
        <p>
          A seleção é realizada por meio de uma entrevista online, gratuita,
          conduzida por uma inteligência artificial treinada na metodologia do
          Empretec. Em aproximadamente 50 minutos, você responde a 5 perguntas
          objetivas. Ao final, recebe o resultado indicando se está apto a
          participar da imersão. Caso ainda não esteja pronto, poderá refazer a
          entrevista após 3 meses.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 3,
    title:
      'Já participei de outras versões do Empretec. \nPosso participar desta versão?',
    description: () => (
      <div>
        <p>
          Sim. Se você já é um Empreteco (a) essa versão foi feita para você.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 4,
    title: 'Qual o investimento para participar do Empretec Arena?',
    description: () => (
      <div>
        <p>
          O investimento para participar do Empretec Arena pode variar de acordo
          com a região. Embora a metodologia seja única e padronizada em todo o
          Brasil, cada unidade estadual do Sebrae define sua própria política de
          preços.
        </p>
        <br />
        <p>
          Para saber o valor e as condições de pagamento, acesse o site do
          Sebrae do seu estado e consulte as informações atualizadas.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 5,
    title: 'Qual é a carga horária?',
    description: () => (
      <div>
        <p>
          O Empretec Arena tem carga total de 44 horas, divididas em duas
          etapas:
        </p>
        <br />
        <p>
          <strong>Pré-seminário (on-line e obrigatório):</strong>
          disponibilizado cinco dias antes do início do seminário e exige cerca
          de 10 horas de dedicação.
        </p>
        <br />

        <p>
          <strong>Seminário presencial e imersivo:</strong>com carga horária
          total de 44 horas, começa na segunda-feira à noite (4 horas) e segue
          até o final do sábado, em jornadas intensas de 8 horas diárias.
        </p>
      </div>
    ),
    opened: false,
  },
];

export const MAP_EMPRETEC_STARTUP_FREQUENT_QUESTIONS = [
  {
    id: 1,
    title: 'Para quem é o Empretec Startup?',
    description: () => (
      <div>
        <p>
          <strong>Empreendedores:</strong> Já possuem uma startup em operação e
          buscam aprimorar suas competências empreendedoras. Estão em busca de
          estratégias para acelerar o crescimento do negócio, otimizar
          processos, inovar continuamente e ampliar sua presença no mercado.
        </p>
        <br />
        <p>
          <strong>Futuros Empreendedores:</strong> Ainda não iniciaram suas
          startups, mas já atuaram ou atuam no ecossistema de inovação. Desejam
          empreender e estão se preparando para lançar o próprio negócio.
        </p>
        <br />
        <p>
          <strong>Decisores:</strong> Profissionais em posições estratégicas
          dentro de startups, com papel ativo na liderança. Buscam impulsionar a
          performance da empresa por meio da melhoria de processos,
          identificação de novas oportunidades e geração de parcerias.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 2,
    title: 'Como me inscrever no Empretec Startup?',
    description: () => (
      <div>
        <p>
          O processo de seleção do Empretec Startup considera critérios
          qualitativos e quantitativos para verificar se o candidato está
          alinhado ao perfil ideal do seminário. Esse alinhamento é fundamental
          para garantir a efetividade da experiência, já que as atividades
          práticas, as trocas de experiências, o conteúdo e a linguagem são
          especialmente desenvolvidos para esse público. A seleção tem início
          com o preenchimento de uma ficha de pré-inscrição.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 3,
    title:
      'Já participei de outras versões do Empretec. \nPosso participar desta versão?',
    description: () => (
      <div>
        <p>
          Quem já participou de outras versões do Empretec não pode se inscrever
          nesta versão. Por outro lado, se você já é Empreteco, pode participar
          do Empretec Arena.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 4,
    title: 'Qual o investimento para participar do Empretec Startup?',
    description: () => (
      <div>
        <p>
          O investimento para participar do Empretec Startup pode variar de
          acordo com a região. Embora a metodologia seja única e padronizada em
          todo o Brasil, cada unidade estadual do Sebrae define sua própria
          política de preços.
        </p>
        <br />
        <p>
          Para saber o valor e as condições de pagamento, acesse o site do
          Sebrae do seu estado e consulte as informações atualizadas.
        </p>
      </div>
    ),
    opened: false,
  },
  {
    id: 5,
    title: 'Qual é a carga horária?',
    description: () => (
      <div>
        <p>
          O Empretec Startup tem carga total de 50 horas, divididas em duas
          etapas:
        </p>
        <br />
        <p>
          <strong>Pré-seminário (on-line e obrigatório):</strong>{' '}
          disponibilizado dez dias antes do início do seminário e exige cerca de
          2 horas de dedicação.
        </p>
        <br />

        <p>
          <strong>Seminário presencial e imersivo:</strong> com duração de 50
          horas, acontece de segunda a sexta, em jornadas intensas de 8 horas
          por dia.
        </p>
      </div>
    ),
    opened: false,
  },
];

export const MAP_EMPRETEC = [
  {
    moduleId: 1,
    bgColor: '#739FF8',
    textButtonCta: 'Quero fazer parte do Empretec',
    bgColorInformations: '#0015C1',
    imgEmpretecLargeDisplay: empretec1,
    imgEmpretecSmallDisplay: mulherEmpretec,
    imgEmpretecDetailSmallDisplay: mulherEmpretecMobile,
    logoEmpretec: logoEmpretec,
    textColor: '#0015C1',
    bgButtonColor: '#699FFF',
    foregroundColor: '#0000C9',
    description:
      'O Empretec é um seminário intensivo para empreendedores, com 60 horas de atividades práticas em 5 dias, sendo 10 horas online antes do seminário se iniciar. Lançado no Brasil em 1993, sua metodologia vivencial busca desenvolver o comportamento empreendedor de forma desafiadora e transformadora.',
    detailDescription: [
      'Lançado no Brasil em 1993, o Empretec é voltado para empreendedores de diversos setores, com exceção da cadeia rural e de startups.',
      'Com uma metodologia vivencial e de alta intensidade, o seminário vai muito além do ensino tradicional: ele provoca, desafia e transforma.',
      'Aqui, o participante não é espectador — é protagonista.',
      'Cada dinâmica foi pensada para despertar e fortalecer o verdadeiro potencial empreendedor, por meio de experiências práticas que colocam à prova comportamentos, atitudes e decisões.',
      ' No Empretec, o conhecimento não é apenas transmitido — ele é vivido, sentido e, acima de tudo, internalizado.',
      <div style={{ marginTop: '24px' }}>
        <TextHeading colorText="#fff">
          5 dias, 60 horas <br />
          10h de atividades pré-seminário e 50 horas presenciais
        </TextHeading>
      </div>,
    ],
  },
  {
    moduleId: 4,
    bgColor: '#83BE73',
    textButtonCta: 'Quero fazer parte do Empretec Rural',
    bgColorInformations: '#477D44',
    imgEmpretecLargeDisplay: empretec2,
    imgEmpretecSmallDisplay: homenRural,
    imgEmpretecDetailSmallDisplay: homenEmpretecRuralMobile,
    logoEmpretec: logoEmpretecRural,
    textColor: '#477D44',
    bgButtonColor: '#BFFABF',
    foregroundColor: '#387F3A',
    description:
      'O Empretec Rural, lançado em 2021, é um seminário voltado para empreendedores do agronegócio. Com metodologia prática e intensa, desenvolve habilidades para aumentar a produtividade, inovar e tornar os negócios rurais mais sustentáveis.',
    detailDescription: [
      'Lançado no Brasil em 2021, o Empretec Rural é exclusivo para empreendedores da cadeia do agronegócio. ',
      'Com uma metodologia vivencial, intensa e adaptada à realidade do agronegócio, o seminário prepara produtores para enfrentarem os desafios do setor com atitude, estratégia e inovação.',
      'Durante o seminário, os participantes desenvolvem habilidades práticas para aumentar a produtividade, tornar seus negócios mais sustentáveis e tirar ideias do papel com segurança. ',

      'Tudo isso em um ambiente dinâmico, que estimula conexões, confiança e ação.',
      <div style={{ marginTop: '24px' }}>
        <TextHeading colorText="#fff">6 dias, 60 horas</TextHeading>
      </div>,
    ],
  },
  {
    moduleId: 3,
    bgColor: '#C380CF',
    textButtonCta: 'Quero fazer parte do Empretec Arena',
    bgColorInformations: '#74307C',
    imgEmpretecLargeDisplay: empretec3,
    imgEmpretecSmallDisplay: homenArena,
    logoEmpretec: logoEmpretecArena,
    imgEmpretecDetailSmallDisplay: homenEmpretecArenaMobile,

    textColor: '#74307C',
    bgButtonColor: '#F0BAF2',
    foregroundColor: '#801080',
    description:
      'Lançado em 2024, o Empretec Arena é uma imersão intensiva e exclusiva para quem já participou de alguma versão do Empretec e quer vivenciar a experiencia novamente. Com formato mais inovador, dinâmico e intenso. Aqui, o empreendedorismo vai além da teoria é um desafio pessoal.',
    detailDescription: [
      'Lançado no Brasil em 2024, o Empretec Arena é voltado exclusivamente para quem já participou de alguma versão do Empretec e quer vivenciar a experiência novamente.',
      'O Empretec Arena é a versão mais inovadora, dinâmica e intensa do Empretec. ',
      'Aqui, o empreendedorismo vai além da teoria — é um desafio pessoal. Você vai experimentar uma nova forma de viver o Empretec: mais rápida, mais ousada e ainda mais transformadora. ',

      <div style={{ marginTop: '24px' }}>
        <TextHeading colorText="#fff">1 noite e 4 dias, 44 horas</TextHeading>
      </div>,
    ],
  },
  {
    moduleId: 2,
    bgColor: '#A1D8F4',
    bgColorInformations: '#63BAF9',
    textButtonCta: 'Quero fazer parte do Empretec Startup',
    imgEmpretecLargeDisplay: empretec4,
    imgEmpretecSmallDisplay: mulherEmpretecStartup,
    logoEmpretec: logoEmpretecStartup,
    imgEmpretecDetailSmallDisplay: mulherEmpretecStartupMobile,

    textColor: '#63BAF9',
    bgButtonColor: '#C4EBFF',
    foregroundColor: '#40BBFF',
    description:
      'O Empretec Startup, lançado em 2023, é voltado exclusivamente para quem é dono de uma startup ou atua no ecossistema de inovação e está se preparando para abrir seu próprio negócio. É uma jornada transformadora que desperta e fortalece o espírito empreendedor no ecossistema de inovação.',

    detailDescription: [
      'Lançado no Brasil em 2023, o Empretec Startup é voltado exclusivamente para quem é dono de uma startup ou atua no ecossistema de inovação e está se preparando para abrir seu próprio negócio. ',
      'O Empretec Startup vai além de um seminário — é uma jornada transformadora que desperta e fortalece o espírito empreendedor no ecossistema de inovação. ',
      'Com uma metodologia vivencial e intensa, prepara futuros fundadores de startups para encarar os desafios do mercado com segurança. ',
      'Totalmente adaptado à lógica ágil e disruptiva do universo das startups, o Empretec oferece prática real, conexões estratégicas e um ambiente dinâmico que inspira confiança para transformar ideias em empresas de alto impacto.',

      <div style={{ marginTop: '24px' }}>
        <TextHeading colorText="#121A21">5 dias, 50 horas</TextHeading>
      </div>,
    ],
  },
];
